
import { Asteroid } from './types';
import { getScaledValue } from './utils';

export class AsteroidManager {
  asteroids: Asteroid[] = [];
  canvasWidth: number;
  canvasHeight: number;
  
  constructor(canvasWidth: number, canvasHeight: number) {
    this.canvasWidth = canvasWidth;
    this.canvasHeight = canvasHeight;
    this.initAsteroids();
  }

  initAsteroids(): void {
    // Create initial asteroids
    const smallerScreen = Math.min(this.canvasWidth, this.canvasHeight);
    const asteroidCount = Math.max(3, Math.floor(smallerScreen / 150)); // Adjust count based on screen size
    
    for (let i = 0; i < asteroidCount; i++) {
      // Position asteroids away from the center (player's starting position)
      let x = Math.random() * this.canvasWidth;
      let y = Math.random() * this.canvasHeight;
      
      // Make sure asteroids don't spawn too close to the player
      while (Math.abs(x - this.canvasWidth/2) < 100 && Math.abs(y - this.canvasHeight/2) < 100) {
        x = Math.random() * this.canvasWidth;
        y = Math.random() * this.canvasHeight;
      }
      
      this.asteroids.push({
        x: x,
        y: y,
        radius: getScaledValue(30 + Math.random() * 20, this.canvasWidth, this.canvasHeight),
        dx: (Math.random() - 0.5) * getScaledValue(2, this.canvasWidth, this.canvasHeight),
        dy: (Math.random() - 0.5) * getScaledValue(2, this.canvasWidth, this.canvasHeight)
      });
    }
  }

  createSplitAsteroids(asteroid: Asteroid): Asteroid[] {
    const newAsteroids: Asteroid[] = [];
    
    for (let i = 0; i < 2; i++) {
      newAsteroids.push({
        x: asteroid.x,
        y: asteroid.y,
        radius: asteroid.radius / 2,
        dx: (Math.random() - 0.5) * getScaledValue(3, this.canvasWidth, this.canvasHeight),
        dy: (Math.random() - 0.5) * getScaledValue(3, this.canvasWidth, this.canvasHeight)
      });
    }
    
    return newAsteroids;
  }

  updatePositions(): void {
    this.asteroids.forEach(asteroid => {
      // Move asteroids
      asteroid.x += asteroid.dx;
      asteroid.y += asteroid.dy;
      
      // Wrap around screen
      if (asteroid.x < 0) asteroid.x = this.canvasWidth;
      if (asteroid.x > this.canvasWidth) asteroid.x = 0;
      if (asteroid.y < 0) asteroid.y = this.canvasHeight;
      if (asteroid.y > this.canvasHeight) asteroid.y = 0;
    });
  }

  resizeAsteroids(newWidth: number, newHeight: number): void {
    const asteroids = this.asteroids.map(asteroid => ({
      xPercent: asteroid.x / this.canvasWidth,
      yPercent: asteroid.y / this.canvasHeight,
      asteroid
    }));
    
    this.canvasWidth = newWidth;
    this.canvasHeight = newHeight;
    
    this.asteroids = asteroids.map(({xPercent, yPercent, asteroid}) => ({
      ...asteroid,
      x: xPercent * newWidth,
      y: yPercent * newHeight,
      radius: getScaledValue(30 + Math.random() * 20, newWidth, newHeight),
      dx: (Math.random() - 0.5) * getScaledValue(2, newWidth, newHeight),
      dy: (Math.random() - 0.5) * getScaledValue(2, newWidth, newHeight)
    }));
  }

  drawAsteroids(ctx: CanvasRenderingContext2D): void {
    this.asteroids.forEach(asteroid => {
      ctx.beginPath();
      ctx.arc(asteroid.x, asteroid.y, asteroid.radius, 0, Math.PI * 2);
      ctx.strokeStyle = '#fff';
      ctx.lineWidth = 2;
      ctx.stroke();
    });
  }
}
